/* istanbul ignore file */
import { createTheme } from '@material-ui/core';
import { ArrowDown } from '@one-thd/sui-icons';
import { THDTypographyStyles } from './typography';

/**
 * Material UI theme for TheHomeDepot
 */
export const THDTheme = createTheme({
  props: {
    MuiAccordion: {
      square: false,
    },
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiButton: {
      fullWidth: true,
      disableRipple: true,
      variant: 'contained',
    },
    MuiCheckbox: {
      disableRipple: true,
    },
    MuiDialog: {},
    MuiIconButton: {
      disableRipple: true,
    },
    MuiInput: {
      name: 'THDInput',
      fullWidth: true,
    },
    MuiInputBase: {
      name: 'THDInputBase',
    },
    MuiRadio: {
      disableRipple: true,
    },
    MuiSelect: {
      disableUnderline: true,
      fullWidth: true,
      IconComponent: ArrowDown,
      MenuProps: {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
      },
    },
    MuiTextField: {
      variant: 'standard',
      fullWidth: true,
      InputLabelProps: { shrink: true },
      InputProps: { disableUnderline: true },
      SelectProps: { disableUnderline: true },
    },
    MuiTooltip: {
      arrow: true,
    },
  },
  typography: THDTypographyStyles,
  breakpoints: {
    values: {
      xs: 320,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  palette: {
    common: {
      black: '#000000',
      white: '#FFFFFF',
    },
    type: 'light',
    primary: {
      main: '#F96302',
      light: '#FDD8C0',
      dark: '#C14C00',
    },
    secondary: {
      // Darken so we reach the AA contrast ratio level.
      main: '#F96302', // darken('#019E84', 0.4),
    },
    error: {
      main: '#E34A4A',
      light: '#FFAFAF',
      dark: '#AB0000',
    },
    warning: {
      main: '#FBC524',
      light: '#FEE9A9',
      dark: '#DDA413',
    },
    info: {
      main: '#62D4CA',
      light: '#B5FFF8',
      dark: '#3B8780',
    },
    success: {
      main: '#1DDB7F',
      light: '#BFE9D4',
      dark: '#009A4F',
    },
    grey: {
      50: '#F4F4F4',
      100: '#E1E1E1',
      200: '#CCCCCB',
      300: '#969695',
      400: '#7A7978',
      500: '#61605F',
      600: '#4B4A4A',
      700: '#373636',
      800: '#212120',
      900: '#121111',
      A100: '#d5d5d5',
      A200: '#aaaaaa',
      A400: '#303030',
      A700: '#616161',
    },
    text: {
      primary: '#212120',
      secondary: '#FFFFFF',
      disabled: '#CCCCCB',
      hint: '#7A7978',
    },
  },
});
